import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './task.types';
import * as constants from './task.constants';

export const storeTask = generateStoreResourceAction<types.ITask>(constants.STORE_TASK);
export const clearTask = generateClearResourceAction(constants.CLEAR_TASK);
